import { runtimeConfig } from "@/lib/runtimeConfig";

const sizeClasses = {
  sm: {
    wrap: "gap-2",
    mark: "h-8 w-8",
    word: "text-lg",
  },
  md: {
    wrap: "gap-2.5",
    mark: "h-9 w-9",
    word: "text-[1.08rem]",
  },
  lg: {
    wrap: "gap-3",
    mark: "h-11 w-11",
    word: "text-2xl",
  },
};

export function BrandMark({ className = "", alt = "Aevo" }) {
  return (
    <img
      src="/aevo-logo-cyan-violet.webp"
      alt={alt}
      className={`object-contain ${className}`}
      loading="eager"
      decoding="async"
      draggable="false"
    />
  );
}

export default function BrandLogo({ className = "", size = "md", tone = "dark" }) {
  const sizing = sizeClasses[size] || sizeClasses.md;
  const textTone = tone === "light" ? "text-white" : "text-foreground";
  const subTone = tone === "light" ? "text-cyan-100/70" : "text-muted-foreground";

  return (
    <span className={`inline-flex items-center ${sizing.wrap} ${className}`}>
      <BrandMark
        alt=""
        className={`${sizing.mark} shrink-0 drop-shadow-[0_14px_28px_rgba(0,231,255,0.22)]`}
      />
      <span className="flex min-w-0 items-baseline gap-1.5">
        <span className={`font-sans ${sizing.word} font-semibold leading-none tracking-tight ${textTone}`}>
          {runtimeConfig.appName}
        </span>
        <span className={`hidden text-[0.62rem] font-bold uppercase tracking-[0.22em] ${subTone} sm:inline`}>
          live
        </span>
      </span>
    </span>
  );
}
